export { default } from './InfluencerTagline';
export { default as adapter } from './adapter';
